import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface ExpandableRowButtonProps {
  isExpanded: boolean;
  onToggle: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

/**
 * Chevron button for expandable table rows
 * Shows ChevronDown when expanded, ChevronRight when collapsed
 */
export function ExpandableRowButton({
  isExpanded,
  onToggle,
  disabled = false
}: ExpandableRowButtonProps) {
  if (disabled) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className="h-6 w-6"
    >
      {isExpanded ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronRight className="h-4 w-4" />
      )}
    </Button>
  );
}
